<template>
  <div id="app">
    <LongForm />
  </div>
</template>
<script>
import LongForm from "@/views/LongForm.vue";
export default {
  name: "App",
  metaInfo: {
    title: "La transizione energetica",
    meta: [
      {
        property: "description",
        content: "Cos’è la transizione energetica e perché è tanto importante per il futuro della nostra società"
      },
      {
        property: "og:title",
        content: `La transizione energetica${process.env.VUE_APP_LANG}`
      },
      {
        property: "og:description",
        content: "Cos’è la transizione energetica e perché è tanto importante per il futuro della nostra società"
      },
      {
        property: "og:image",
        content: "images/Foto1_mobile.jpg"
      }
    ]
  },
  components: {
    LongForm
  }
};
</script>
<style lang="scss">
:root {
  box-sizing: border-box;
}

*,
::before,
::after {
  box-sizing: inherit;
}

body {
  margin: 0;
}
#app {
  overflow: hidden;
}
.tva-row {
  max-width: 1200px;
  margin: 0 auto;
  div:first-child {
    padding-left: 0 !important;
  }
  div:last-child {
    padding-right: 0 !important;
  }
  .tva-col-xs-1,
  .tva-col-sm-1,
  .tva-col-md-1,
  .tva-col-lg-1,
  .tva-col-xs-2,
  .tva-col-sm-2,
  .tva-col-md-2,
  .tva-col-lg-2,
  .tva-col-xs-3,
  .tva-col-sm-3,
  .tva-col-md-3,
  .tva-col-lg-3,
  .tva-col-xs-4,
  .tva-col-sm-4,
  .tva-col-md-4,
  .tva-col-lg-4,
  .tva-col-xs-5,
  .tva-col-sm-5,
  .tva-col-md-5,
  .tva-col-lg-5,
  .tva-col-xs-6,
  .tva-col-sm-6,
  .tva-col-md-6,
  .tva-col-lg-6,
  .tva-col-xs-7,
  .tva-col-sm-7,
  .tva-col-md-7,
  .tva-col-lg-7,
  .tva-col-xs-8,
  .tva-col-sm-8,
  .tva-col-md-8,
  .tva-col-lg-8,
  .tva-col-xs-9,
  .tva-col-sm-9,
  .tva-col-md-9,
  .tva-col-lg-9,
  .tva-col-xs-10,
  .tva-col-sm-10,
  .tva-col-md-10,
  .tva-col-lg-10,
  .tva-col-xs-11,
  .tva-col-sm-11,
  .tva-col-md-11,
  .tva-col-lg-11,
  .tva-col-xs-12,
  .tva-col-sm-12,
  .tva-col-md-12,
  .tva-col-lg-12 {
    position: relative;
    min-height: 1px;
    padding-left: 15px;
    padding-right: 15px;
  }
  .tva-col-xs-1,
  .tva-col-xs-2,
  .tva-col-xs-3,
  .tva-col-xs-4,
  .tva-col-xs-5,
  .tva-col-xs-6,
  .tva-col-xs-7,
  .tva-col-xs-8,
  .tva-col-xs-9,
  .tva-col-xs-10,
  .tva-col-xs-11,
  .tva-col-xs-12 {
    display: inline-block;
  }
  .tva-col-xs-12 {
    width: 100%;
  }
  .tva-col-xs-11 {
    width: 91.66666667%;
  }
  .tva-col-xs-10 {
    width: 83.33333333%;
  }
  .tva-col-xs-9 {
    width: 75%;
  }
  .tva-col-xs-8 {
    width: 66.66666667%;
  }
  .tva-col-xs-7 {
    width: 58.33333333%;
  }
  .tva-col-xs-6 {
    width: 50%;
  }
  .tva-col-xs-5 {
    width: 41.66666667%;
  }
  .tva-col-xs-4 {
    width: 33.33333333%;
  }
  .tva-col-xs-3 {
    width: 25%;
  }
  .tva-col-xs-2 {
    width: 16.66666667%;
  }
  .tva-col-xs-1 {
    width: 8.33333333%;
  }
  .tva-col-xs-offset-12 {
    margin-left: 100%;
  }
  .tva-col-xs-offset-11 {
    margin-left: 91.66666667%;
  }
  .tva-col-xs-offset-10 {
    margin-left: 83.33333333%;
  }
  .tva-col-xs-offset-9 {
    margin-left: 75%;
  }
  .tva-col-xs-offset-8 {
    margin-left: 66.66666667%;
  }
  .tva-col-xs-offset-7 {
    margin-left: 58.33333333%;
  }
  .tva-col-xs-offset-6 {
    margin-left: 50%;
  }
  .tva-col-xs-offset-5 {
    margin-left: 41.66666667%;
  }
  .tva-col-xs-offset-4 {
    margin-left: 33.33333333%;
  }
  .tva-col-xs-offset-3 {
    margin-left: 25%;
  }
  .tva-col-xs-offset-2 {
    margin-left: 16.66666667%;
  }
  .tva-col-xs-offset-1 {
    margin-left: 8.33333333%;
  }
  .tva-col-xs-offset-0 {
    margin-left: 0%;
  }
  @media (max-width: 768px) {
    padding: 0 15px;
  }
  @media (min-width: 768px) {
    .tva-col-sm-1,
    .tva-col-sm-2,
    .tva-col-sm-3,
    .tva-col-sm-4,
    .tva-col-sm-5,
    .tva-col-sm-6,
    .tva-col-sm-7,
    .tva-col-sm-8,
    .tva-col-sm-9,
    .tva-col-sm-10,
    .tva-col-sm-11,
    .tva-col-sm-12 {
      display: inline-block;
    }
    .tva-col-sm-12 {
      width: 100%;
    }
    .tva-col-sm-11 {
      width: 91.66666667%;
    }
    .tva-col-sm-10 {
      width: 83.33333333%;
    }
    .tva-col-sm-9 {
      width: 75%;
    }
    .tva-col-sm-8 {
      width: 66.66666667%;
    }
    .tva-col-sm-7 {
      width: 58.33333333%;
    }
    .tva-col-sm-6 {
      width: 50%;
    }
    .tva-col-sm-5 {
      width: 41.66666667%;
    }
    .tva-col-sm-4 {
      width: 33.33333333%;
    }
    .tva-col-sm-3 {
      width: 25%;
    }
    .tva-col-sm-2 {
      width: 16.66666667%;
    }
    .tva-col-sm-1 {
      width: 8.33333333%;
    }
    .tva-col-sm-offset-12 {
      margin-left: 100%;
    }
    .tva-col-sm-offset-11 {
      margin-left: 91.66666667%;
    }
    .tva-col-sm-offset-10 {
      margin-left: 83.33333333%;
    }
    .tva-col-sm-offset-9 {
      margin-left: 75%;
    }
    .tva-col-sm-offset-8 {
      margin-left: 66.66666667%;
    }
    .tva-col-sm-offset-7 {
      margin-left: 58.33333333%;
    }
    .tva-col-sm-offset-6 {
      margin-left: 50%;
    }
    .tva-col-sm-offset-5 {
      margin-left: 41.66666667%;
    }
    .tva-col-sm-offset-4 {
      margin-left: 33.33333333%;
    }
    .tva-col-sm-offset-3 {
      margin-left: 25%;
    }
    .tva-col-sm-offset-2 {
      margin-left: 16.66666667%;
    }
    .tva-col-sm-offset-1 {
      margin-left: 8.33333333%;
    }
    .tva-col-sm-offset-0 {
      margin-left: 0%;
    }
  }
  @media (min-width: 992px) {
    .tva-col-md-1,
    .tva-col-md-2,
    .tva-col-md-3,
    .tva-col-md-4,
    .tva-col-md-5,
    .tva-col-md-6,
    .tva-col-md-7,
    .tva-col-md-8,
    .tva-col-md-9,
    .tva-col-md-10,
    .tva-col-md-11,
    .tva-col-md-12 {
      display: inline-block;
    }
    .tva-col-md-12 {
      width: 100%;
    }
    .tva-col-md-11 {
      width: 91.66666667%;
    }
    .tva-col-md-10 {
      width: 83.33333333%;
    }
    .tva-col-md-9 {
      width: 75%;
    }
    .tva-col-md-8 {
      width: 66.66666667%;
    }
    .tva-col-md-7 {
      width: 58.33333333%;
    }
    .tva-col-md-6 {
      width: 50%;
    }
    .tva-col-md-5 {
      width: 41.66666667%;
    }
    .tva-col-md-4 {
      width: 33.33333333%;
    }
    .tva-col-md-3 {
      width: 25%;
    }
    .tva-col-md-2 {
      width: 16.66666667%;
    }
    .tva-col-md-1 {
      width: 8.33333333%;
    }
    .tva-col-md-offset-12 {
      margin-left: 100%;
    }
    .tva-col-md-offset-11 {
      margin-left: 91.66666667%;
    }
    .tva-col-md-offset-10 {
      margin-left: 83.33333333%;
    }
    .tva-col-md-offset-9 {
      margin-left: 75%;
    }
    .tva-col-md-offset-8 {
      margin-left: 66.66666667%;
    }
    .tva-col-md-offset-7 {
      margin-left: 58.33333333%;
    }
    .tva-col-md-offset-6 {
      margin-left: 50%;
    }
    .tva-col-md-offset-5 {
      margin-left: 41.66666667%;
    }
    .tva-col-md-offset-4 {
      margin-left: 33.33333333%;
    }
    .tva-col-md-offset-3 {
      margin-left: 25%;
    }
    .tva-col-md-offset-2 {
      margin-left: 16.66666667%;
    }
    .tva-col-md-offset-1 {
      margin-left: 8.33333333%;
    }
    .tva-col-md-offset-0 {
      margin-left: 0%;
    }
  }
  @media (min-width: 1200px) {
    .tva-col-lg-1,
    .tva-col-lg-2,
    .tva-col-lg-3,
    .tva-col-lg-4,
    .tva-col-lg-5,
    .tva-col-lg-6,
    .tva-col-lg-7,
    .tva-col-lg-8,
    .tva-col-lg-9,
    .tva-col-lg-10,
    .tva-col-lg-11,
    .tva-col-lg-12 {
      width: 100%;
    }
    .tva-col-lg-11 {
      width: 91.66666667%;
    }
    .tva-col-lg-10 {
      width: 83.33333333%;
    }
    .tva-col-lg-9 {
      width: 75%;
    }
    .tva-col-lg-8 {
      width: 66.66666667%;
    }
    .tva-col-lg-7 {
      width: 58.33333333%;
    }
    .tva-col-lg-6 {
      width: 50%;
    }
    .tva-col-lg-5 {
      width: 41.66666667%;
    }
    .tva-col-lg-4 {
      width: 33.33333333%;
    }
    .tva-col-lg-3 {
      width: 25%;
    }
    .tva-col-lg-2 {
      width: 16.66666667%;
    }
    .tva-col-lg-1 {
      width: 8.33333333%;
    }
    .tva-col-lg-offset-12 {
      margin-left: 100%;
    }
    .tva-col-lg-offset-11 {
      margin-left: 91.66666667%;
    }
    .tva-col-lg-offset-10 {
      margin-left: 83.33333333%;
    }
    .tva-col-lg-offset-9 {
      margin-left: 75%;
    }
    .tva-col-lg-offset-8 {
      margin-left: 66.66666667%;
    }
    .tva-col-lg-offset-7 {
      margin-left: 58.33333333%;
    }
    .tva-col-lg-offset-6 {
      margin-left: 50%;
    }
    .tva-col-lg-offset-5 {
      margin-left: 41.66666667%;
    }
    .tva-col-lg-offset-4 {
      margin-left: 33.33333333%;
    }
    .tva-col-lg-offset-3 {
      margin-left: 25%;
    }
    .tva-col-lg-offset-2 {
      margin-left: 16.66666667%;
    }
    .tva-col-lg-offset-1 {
      margin-left: 8.33333333%;
    }
    .tva-col-lg-offset-0 {
      margin-left: 0%;
    }
  }
}
</style>
